<template>
  <div
    class="modal-window bds072 bds057 decis"
    @dragover="decisionDragDropFile($event, 'over')"
    @dragleave="decisionDragDropFile($event, 'leave')"
    @drop="decisionDragDropFile($event, 'drop')"
  >
    <header class="modal-header">
      <div class="tit">
        <span class="cursor-pointer" @click="boardLink">{{
          editorData.paperTitle
        }}</span>
      </div>
      <button @click="closePopup" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="top">
        <div class="date">
          {{ $i18nUtil.trans("message.requestDate","요청일") }} {{ $moment(item.regDate).format("YYYY.MM.DD") }}
        </div>
        <div class="droplayer tooltipmember relative right avatar">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="getMemberTooltip(editorData.regUserId)"
                ><div
                  class="avatar img user-photo"
                  :data-user-id="editorData.regUserId"
                >
                  <img src="@/assets/img/no-avatar.png" alt="" />
                </div>
                {{ editorData.regUserName }}</v-btn
              >
            </template>
            <div class="dropdown-list">
              <UserTooltip :userId="editorData.regUserId" />
            </div>
          </v-menu>
        </div>
      </div>

      <div class="scroll">
        <div class="inner">
          <textarea
            name=""
            id="info"
            @keyup="doCheck(500)"
            maxlength="501"
            v-model="editorData.contents"
            v-if="
              editorData.regUserId == userInfo.userId &&
              editorData.isEditFlag === true
            "
          ></textarea>
          <textarea
            name=""
            id="info"
            @keyup="doCheck(500)"
            maxlength="501"
            v-model="editorData.contents"
            v-else
            readonly
            onfocus="this.blur()"
          ></textarea>
          <div class="character-limit_box txtr">
            <span class="error" v-if="error"
              >{{ $i18nUtil.trans("message.exceed.characters","입력 가능한 글자수를 초과하였습니다.") }}({{
                editorData.contents.length
              }}/500)</span
            >
            <span class="count">
              <!-- (<b>{{ editorData.contents.length }} </b>/500) -->
            </span>
          </div>

          <div
            class="txtr"
            v-if="
              editorData.regUserId == userInfo.userId &&
              editorData.isEditFlag === true
            "
          >
            <div
              class="droplayer relative right attach nosel"
              :class="{ 'no-attach': upfile.files.length == 0 }"
            >
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">{{ $i18nUtil.trans("entity.file","첨부파일") }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <form style="display: none">
                        <input
                          multiple
                          type="file"
                          id="fileUpload"
                          @change="OpinionChangeFile()"
                          ref="opiUploadfile"
                        />
                      </form>
                      <button
                        type="button"
                        @click="$refs.opiUploadfile.click()"
                      >
                        {{ $i18nUtil.trans("button.fileUpload.computer","내 컴퓨터") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button type="button" @click="boardFile()">
                        {{ $i18nUtil.trans("title.OpinionBoardFile.001","보드 내 파일 추가") }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
          </div>
          <div class="attachfile_box">
            <div class="scroll decisionDropZone" ref="decisionDropZone">
              <div
                class="file_row clear"
                v-for="(fileItem, fileIndex) in upfile.files"
                :key="fileIndex"
                :transfer-data="fileItem"
              >
                <div
                  class="file_name ell-singleline"
                  :class="icoFile(fileItem)"
                  @click="
                    callFileViewer({
                      type: 'SINGLE',
                      file: Object(fileItem),
                    })
                  "
                >
                  {{ fileItem.name || fileItem.fileName }}
                </div>
                <div class="btn">
                  <div class="droplayer icon more large right nosel">
                    <v-menu
                      bottom
                      left
                      v-if="editorData.regUserId == userInfo.userId"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                      </template>
                      <div class="dropdown-list">
                        <div class="dropdown-list-item">
                          <div class="tit">
                            <button
                              type="button"
                              @click="confirmDelFile(fileItem, fileIndex)"
                            >
                              {{ $i18nUtil.trans("button.file.delete","파일 삭제") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="todo_wrap_write"
        v-if="
          editorData.regUserId == userInfo.userId && editorData.status == 'APPL'
        "
      >
        <div class="top">
          <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
          <div class="status-txt" v-if="editorData.status === 'APPL'">
            {{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}
          </div>

          <div class="status-txt" v-else-if="editorData.status === 'APROVAL'">
            {{ $i18nUtil.trans("entity.decision.status.approval","승인") }}
          </div>
          <div class="status-txt" v-else-if="editorData.status === 'RETURN'">
            {{ $i18nUtil.trans("entity.decision.status.reject","반려") }}
          </div>
          <div class="status-txt" v-else></div>
          <div class="dividing_line_ty2"></div>
          <div
            class="droplayer tooltipmember relative avatar"
            v-if="editorData.status != 'APPL' && editorData.deciDate != null"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <div
                    class="avatar img user-photo"
                    :data-user-id="editorData.userId"
                  >
                    <img src="@/assets/img/no-avatar.png" alt="" />
                  </div>
                  {{ editorData.userName }}
                </v-btn>
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="editorData.userId"></UserTooltip>
              </div>
            </v-menu>
          </div>
          <div class="dropdown ty1 relative avatar b">
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn
                  
                  @click="showMemberSearch"
                  v-bind="attrs"
                  v-on="on"
                  >{{ deciTarget }}</v-btn
                > -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  ref="memberSearchBtn"
                  @click="showMemberSearch"
                  ><div
                    class="avatar img user-photo"
                    :data-user-id="editorData.userId"
                  >
                    <img src="@/assets/img/no-avatar.png" alt="" />
                  </div>
                  {{ editorData.userName }}</v-btn
                >
              </template>
              <div ref="memberSearchList" class="dropdown-list">
                <div class="search top">
                  <form action="" onsubmit="return false;">
                    <div class="search_ty1">
                      <input
                        type="text"
                        @focus="$event.target.placeholder = ''"
                        @focusout="
                          $event.target.placeholder = $i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')
                        "
                        :placeholder="$i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')"
                        @keyup.enter="searchByKeyword"
                        @keydown="searchByKeyword"
                        @input="searchByKeyword"
                      />
                      <button
                        type="reset"
                        class="btn_search"
                        @click="clickMemberSearchBtn"
                      >
                        검색
                      </button>
                    </div>
                  </form>
                </div>
                <div class="member-call-box search">
                  <div class="scroll">
                    <div class="nodata" v-if="!isSearch">
                      <div class="txt" v-html="$i18nUtil.trans('message.BoardOpinionModal.006','결정자 지정하여<br />의사결정을 요청해보세요.')">
                      </div>
                    </div>
                    <div class="nodata" v-else-if="searchUserList.length == 0">
                      <div class="txt" v-html="$i18nUtil.trans('search.012','해당 검색어와 일치하는 사용자가 없습니다.')">
                      </div>
                    </div>
                    <dl v-if="isSearch && searchUserList.length > 0">
                      <dt>{{ $i18nUtil.trans("message.member.searchResult","멤버 검색 결과") }}</dt>
                      <dd>
                        <div class="nodata" v-if="searchMemberList.length == 0" v-html="$i18nUtil.trans('search.012','해당 검색어와 일치하는 사용자가 없습니다.')">
                        </div>
                        <ul class="member-list" v-else>
                          <li
                            v-for="(item, index) in searchMemberList"
                            :key="'member' + index"
                            :data-user-id="item.userId"
                            :data-user-name="item.userName"
                            @click="setuserId(item.userId, item.userName)"
                          >
                            <div
                              class="img user-photo"
                              :data-user-id="item.userId"
                            >
                              <img src="@/assets/img/no-avatar.png" alt="" />
                            </div>
                            <b class="name ell-singleline"
                              >{{ item.userName }}
                              <span>{{ item.jobPositionName }}</span></b
                            >
                            <span class="team ell-singleline"
                              >{{ item.companyName }} /
                              {{
                                item.isExternalUser
                                  ? item.partnerName
                                  : item.deptName
                              }}</span
                            >
                          </li>
                        </ul>
                      </dd>
                    </dl>
                    <dl
                      v-if="
                        isSearch &&
                        searchUserList.length > 0 &&
                        modalInfo.paperInfo.internalUserYn
                      "
                    >
                      <dt v-html="$i18nUtil.trans('search.050','멤버 외 검색 결과 (등록 완료 시 멤버로 자동 추가됩니다.)')">
                      </dt>
                      <dd>
                        <div
                          class="nodata"
                          v-if="searchNoMemberList.length == 0"
                          v-html="$i18nUtil.trans('search.012','해당 검색어와 일치하는 사용자가 없습니다.')">
                        >
                        </div>
                        <ul class="member-list" v-else>
                          <li
                            v-for="(item, index) in searchNoMemberList"
                            :key="'noMember' + index"
                            :data-user-id="item.userId"
                            :data-user-name="item.userName"
                            @click="setuserId(item.userId, item.userName)"
                          >
                            <div
                              class="img user-photo"
                              :data-user-id="item.userId"
                            >
                              <img src="@/assets/img/no-avatar.png" alt="" />
                            </div>
                            <b class="name ell-singleline"
                              >{{ item.userName }}
                              <span>{{ item.jobPositionName }}</span></b
                            >
                            <span class="team ell-singleline"
                              >{{ item.companyName }} /
                              {{
                                item.isExternalUser
                                  ? item.partnerName
                                  : item.deptName
                              }}</span
                            >
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="search bottom">
                  <form action="" onsubmit="return false;">
                    <div class="search_ty1">
                      <input
                        type="text"
                        @focus="$event.target.placeholder = ''"
                        @focusout="
                          $event.target.placeholder = $i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')
                        "
                        :placeholder="$i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')"
                        @keyup.enter="searchByKeyword"
                        @keydown="searchByKeyword"
                        @input="searchByKeyword"
                      />
                      <button
                        type="reset"
                        class="btn_search"
                        @click="clickMemberSearchBtn"
                      >
                        검색
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </v-menu>
          </div>

          <!-- <div class="dropdown ty1 relative avatar" v-else>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                  ><div
                    class="avatar img user-photo"
                    :data-user-id="editorData.userId"
                  >
                    <img src="@/assets/img/no-avatar.png" alt="" />
                  </div>
                  {{ editorData.userName }}</v-btn
                >
              </template>
              <div class="dropdown-list list" style="width: 300px">
                <div class="scroll">
                  <ul class="membersearchlist">
                    <li
                      v-for="(member, index) in members"
                      :key="'member' + index"
                      :data-user-id="member.userId"
                      @click="
                        setuserId(
                          member.userId || member.paperUserId,
                          member.userName
                        )
                      "
                    >
                      <div
                        class="avatar img user-photo"
                        :data-user-id="member.userId"
                      >
                        <img src="@/assets/img/no-avatar.png" alt="" />
                      </div>
                      <b class="name"
                        >{{ member.userName
                        }}<span>{{ member.deptName }}</span></b
                      >
                      <span class="mail ell-singleline">
                        {{ member.companyName }} /
                        {{
                          member.isExternalUser
                            ? member.partnerName
                            : member.deptName
                        }}</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </v-menu>
          </div> -->
        </div>
        <!-- <div v-if="editorData.status != 'APPL' && editorData.deciDate != null">
          결정일 :
          {{ replaceAll(editorData.deciDate.substring(0, 10), "-", ".") }}
        </div> -->

        <div class="write_grp">
          <textarea
            type="text"
            readonly
            :placeholder="$i18nUtil.trans('message.BoardOpinionModal.022','의사결정 기다리는 중')"
            :value="editorData.pcontents"
          />
        </div>
      </div>

      <div class="todo_wrap_write" v-else>
        <div class="top clear">
          <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
          <div class="status-txt" v-if="editorData.status === 'APPL'">
            {{ $i18nUtil.trans("entity.decision.status.proceeding","승인 전") }}
          </div>

          <div class="status-txt" v-else-if="editorData.status === 'APROVAL'">
            {{ $i18nUtil.trans("entity.decision.status.approval","승인") }}
          </div>
          <div class="status-txt" v-else-if="editorData.status === 'RETURN'">
            {{ $i18nUtil.trans("entity.decision.status.reject","반려") }}
          </div>
          <div class="status-txt" v-else></div>
          <div class="droplayer tooltipmember relative right avatar fr">
            <div
              class="date"
              v-if="editorData.status != 'APPL' && editorData.deciDate != null"
            >
              {{ $i18nUtil.trans("entity.decision.filter.decisionDate","결정일") }}
              {{ replaceAll(editorData.deciDate.substring(0, 10), "-", ".") }}
            </div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="getMemberTooltip(editorData.userId)"
                >
                  <div
                    class="avatar img user-photo"
                    :data-user-id="editorData.userId"
                  >
                    <img src="@/assets/img/no-avatar.png" alt="" />
                  </div>
                  {{ editorData.userName }}
                </v-btn>
              </template>
              <div class="dropdown-list">
                <div
                  class="tooltip-b tl small member"
                  :id="'tooltip' + editorData.userId"
                >
                  <ul class="">
                    <li>
                      <div class="row1">
                        <div
                          class="avatar img user-photo"
                          :data-user-id="editorData.userId"
                        >
                          <img src="@/assets/img/no-avatar.png" alt="" />
                        </div>
                        <div class="name">
                          {{ deptInfo.userName }}
                          <span>{{ deptInfo.jobPositionName }}</span>
                        </div>
                        <div class="co">
                          <span>{{ deptInfo.companyName }}</span>
                          <span>{{ deptInfo.deptName }}</span>
                        </div>
                      </div>
                      <div class="mail ell-singleline">
                        {{ deptInfo.email }}
                      </div>
                      <div class="tel">{{ deptInfo.cellPhoneNo }}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </v-menu>
          </div>
        </div>

        <div class="write_grp">
          <!-- v-if="
            editorData.status == 'APPL' ||
            (editorData.pcontents != null && editorData.pcontents.length > 0)
          " -->
          <textarea
            v-show="editorData.emoticonId == null || editorData.pcontents != ''"
            :placeholder="
              editorData.status == 'APPL' &&
              editorData.pcontents != null &&
              editorData.pcontents.length > 0
                ? $i18nUtil.trans('message.BoardOpinionModal.022','의사결정 기다리는 중')
                : $i18nUtil.trans('message.BoardOpinionModal.023','등록된 의견이 없습니다.')
            "
            readonly
            onfocus="this.blur()"
            v-model="editorData.pcontents"
          >
          </textarea>
          <div class="txt reply-emoticon" v-show="editorData.emoticonId != null">
            <img v-if="editorData.emoticonId != null" :src="$emoticonFn.getEmoticonSrc(tenantId, editorData.emoticonId)">
          </div>
        </div>
        <!-- <div class="write_grp" v-else>
          <textarea
            placeholder="의견이 없습니다."
            readonly
            onfocus="this.blur()"
            v-model="editorData.pcontents"
          >
          </textarea>
        </div> -->
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="boardLink"> 
        {{ $i18nUtil.trans("button.board.move","{board} 이동", {board: $i18nUtil.trans("entity.paper","보드") }) }}
      </button>
      <button
        type="button"
        class="btn_ty1"
        @click="onSubmitFormUpdate()"
        v-if="
          editorData.status === 'APPL' &&
          editorData.regUserId == userInfo.userId
        "
      >
        {{ $i18nUtil.trans("button.save","저장") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
import boardFile from "../opinion/OpinionBoardFile.vue";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import lodash from "lodash";
import axios from "axios";

export default {
  components: {
    UserTooltip,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      error: false,
      searchKeyword: "",
      isSearch: false,
      searchUserList: [],
      searchMemberList: [],
      searchNoMemberList: [],
      state: {
        memberIndex: [0],
      },
      editorData: {
        deciId: null,
        deciName: null,
        paperId: null,
        paperTitle: null,
        contents: null,
        pcontents: null,
        paperFileId: null,
        deciProcessId: null,
        userId: null,
        userName: null,
        userId: null,
        userName: null,
        regUserId: null,
        regUserName: null,
        status: null,
        isEditFlag: false,
        isProcessEditFlag: false,
      },
      upfile: {
        groupId: "",
        paperId: "",
        files: [],
      },
      data: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null,
      },
      deleteFileList:[],
      item: {},
      items: [],
      members: [],
      userInfo: {
        userId: null,
      },
      uploadDecisionFile: [],
      udfform: {
        paperFileId: null,
        seq: null,
        fileId: null,
        fileName: null,
      },
      paperBlock: {},
      checked: [],
      deptInfo: {
        userName: "",
        jobPositionName: "",
        companyName: "",
        deptName: "",
        email: "",
        cellPhoneNo: "",
      },
      userListS: [],
      userList: this.modalInfo.userList,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      tenantId: localStorage.getItem('tenantId')
    };
  },
  updated() {
    this.updateUserPhoto();
  },
  created() {
    let body = document.querySelector("body");
    body.style.overflow = "hidden";
    let obj = this;

    this.item = this.modalInfo.item;
    this.getUserInfo();
    this.getModalsDecision();
    this.initPaperUserList();
    EventBus.$on("copyBlockFile", (payload) => {
      if (payload.deciId === this.editorData.deciId) {
        let files = payload.chkval;
        if (files.length) {
          for (let i = 0; i < files.length; i++) {
            this.upfile.files.push(files[i]);
          }
        }
      }
    });
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("evdControl", ["SIMPLE_KBD_SCROLL"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO", "CHECK_AND_LAUNCH"]),
    doCheck(max) {
      this.count = document.getElementById("info").value.length;
      if (this.count > max) {
        this.error = true;
      } else {
        this.error = false;
      }
    },
    getUserInfo() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/userInfo",
        method: "post",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.userInfo = response.result;
      });
    },
    getModalsDecision() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/getModalsDecision",
        method: "post",
        params: { paperId: this.item.paperId, deciId: this.item.deciId },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode != null) {
          obj.closePopup();
        } else {
          obj.editorData = response.result;
          
          if(obj.$i18nUtil.getLanguage() === 'ko') {
            // locale에 따른 사용자명 영문 처리
          }else{
            obj.editorData.regUserName = obj.editorData.regUserNameEn != null ? obj.editorData.regUserNameEn : obj.editorData.regUserName;
            obj.editorData.userName = obj.editorData.userNameEn != null ? obj.editorData.userNameEn : obj.editorData.userName;
          }

          this.getGroupIdAndProjectIdToPaperId();
          this.confirm();
        }
      });
    },
    getGroupIdAndProjectIdToPaperId() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/getGroupIdAndProjectIdToPaperId",
        method: "post",
        params: { paperId: this.item.paperId },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        this.upfile.groupId = response.result.groupId;
      });
    },
    confirm() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/confirm",
        method: "post",
        params: {
          deciId: this.editorData.deciId,
          userId: this.editorData.userId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData);
    },
    status(_status, param) {
      param.pcontents = this.editorData.pcontents;
      param.status = _status;
      let _obj = this;
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/process",
        method: "post",
        params: param,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        _obj.items = response.result;
        _obj.$emit("closeBoardLeftModal", _obj.items);
        _obj.closePopup();
      });
    },
    initPaperUserList() {
      let newMember = [];
      let obj = this;
      let reqData = {
        url: "/api/copaper/paperuser/getPaperUserList",
        method: "post",
        params: {
          paperId: this.item.paperId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let result = response.result;
        result.userList.forEach((item) => {
          if (item.userId != obj.userInfo.userId) {
            obj.members.push(item);
          }
        });
        obj.initDecisionThisFile();
      });
    },
    initDecisionThisFile() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/decisionThisFile",
        method: "post",
        params: this.item,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.upfile.files = response.result;
        if (obj.upfile.files.length == 0) {
          let fileDiv = document.querySelector("div.attachfile_box");
          fileDiv.style.minHeight = "11px";
        }
        obj.initPaperGroupId();
      });
    },
    initPaperGroupId() {
      let obj = this;
      obj.upfile.paperId = obj.editorData.paperId;
      // 접속자 권한 확인
      // 작성자
      if (obj.editorData.regUserId == obj.userInfo.userId) {
        // 진행상태구분(APPL:신청,APROVAL:승인완료,RETURN:반려,DEFER:보류)
        if (
          obj.editorData.status == null ||
          obj.editorData.status == "" ||
          obj.editorData.status == "APPL"
        ) {
          obj.editorData.isEditFlag = true;
        }
      }
      // 결정자
      if (obj.editorData.userId == obj.userInfo.userId) {
        // 진행상태구분(APPL:신청,APROVAL:승인완료,RETURN:반려,DEFER:보류)
        if (
          obj.editorData.status == null ||
          obj.editorData.status == "" ||
          obj.editorData.status == "APPL"
        ) {
          obj.editorData.isProcessEditFlag = true;
        }
      }
      // });
    },
    getDecisionThisFile() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/decisionThisFile",
        method: "post",
        params: this.item,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.upfile.files = response.result;
      });
    },
    getPaperUserList() {
      let obj = this;

      let reqData = {
        url: "/api/copaper/paperuser/getPaperUserList",
        method: "post",
        params: {
          paperId: this.editorData.paperId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let result = response.result;
        for (let i = 0; i < result.userList.length; i++) {
          var member = { userId: "", userName: "" };
          member.userId = result.userList[i].userId;
          member.userName = result.userList[i].userName;
          newMember.push(member);
        }
        obj.members = newMember;

        let targetIndex = -1;
        obj.members.forEach((elem, index) => {
          let memberUserId = elem.userId || elem.paperUserId;
          if (memberUserId === obj.userInfo.userId) {
            targetIndex = index;
          }
        });
        if (targetIndex !== -1) {
          obj.members.splice(targetIndex, 1);
        }
      });
    },
    setuserId(param1, param2) {
      if (this.editorData.regUserId == param1) {
        this.showAlertDialog(this.$i18nUtil.trans("AB078"), null, {
          width: "440px",
        });
        return;
      }
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/checkBlockPolicy";
      reqData.method = "post";
      reqData.params = {
        paperId: this.editorData.paperId,
        userId: param1,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode) {
          console.log(response.errorCode);
        } else {
          if(response.result.checkPolicy && response.result.checkPolicy.length >0 ){
            let checkPolicy = "";
            response.result.checkPolicy.forEach((res)=>{
              checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
            })
            obj.showAlertDialog(obj.$i18nUtil.trans("AB112",{ checkPolicy: checkPolicy}));
            return;
          }

          if (response.result) {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.member.blocked","정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.");
              // "정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.";
            obj.showToast(obj.toastInfo);
          } else {
            obj.editorData.userId = param1;
            obj.editorData.userName = param2;

            obj.searchKeyword = "";
            obj.searchUserList = [];
            obj.searchMemberList = [];
            obj.searchNoMemberList = [];
            obj.isSearch = false;
          }
        }
      });

      let element = this.$el.querySelectorAll(
        ".v-btn.v-btn--contained.theme--light.v-size--default"
      );
      element[2].click();
      // for (let i = 0; i < element.length; i++) {
      //   if (element[i].getAttribute("aria-expanded")) {
      //     element[3].click();
      //   }
      // }

      // document
      //   .getElementById("deciDt-" + this.bdata.paperBlockId)
      //   .classList.toggle("active");
    },
    // setuserId(param1, param2) {
    //   if (this.editorData.regUserId == param1) {
    //     this.showAlertDialog(this.$i18nUtil.trans("AB078"), null, {
    //       width: "440px",
    //     });
    //     return;
    //   }

    //   this.editorData.userId = param1;
    //   this.editorData.userName = param2;
    // },
    confirmDelFile(_fileItem, _fileIndex) {
      let obj = this;

      if(_fileItem != null && _fileItem.fileId != null){
        let reqDataModalsDecision = {
          url: "/api/copaper/decision/getModalsDecision",
          method: "post",
          params: { paperId: this.item.paperId, deciId: this.item.deciId },
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqDataModalsDecision).then((response) => {
          let editorData2 = response.result;
          if (editorData2.confirm > 0) {
            obj.showAlertDialog(obj.$i18nUtil.trans("AB067"), null, {width: "440px",});
            return;
          }else{ 
            let checkData = {
              url: "/api/copaper/decision/checkUploadStatus",
              method: "post",
              params: _fileItem,
            };
            obj.COWORK_REST_SIMPLE_ACTION(checkData).then(function (res) {
              let uploadStatus = res.result.uploadStatus;
              if (uploadStatus == "COMPLETE") {
                  obj.setDeleteFileList(
                { fileItem: _fileItem, fileIndex: _fileIndex });
              } else {
                obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.024","첨부하신 파일이 아직 업로드 중입니다. 잠시 후 다시 시도해주세요.");
                obj.showToast(obj.toastInfo);
              }
            }).catch(function (err) {
              obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.024","첨부하신 파일이 아직 업로드 중입니다. 잠시 후 다시 시도해주세요.");
              obj.showToast(obj.toastInfo);
            });
          }
        });
      }else{
        if ($("#btn_etc_opinionu" + _fileIndex) != null 
            && $("#btn_etc_opinionu" + _fileIndex).length > 0 ) {
          $("#btn_etc_opinionu" + _fileIndex)[0].classList.toggle("active");
        }
        this.upfile.files.splice(_fileIndex, 1);
      }
    },
    setDeleteFileList(item){
      let _fileItem = item.fileItem;
      let _fileIndex = item.fileIndex;

      if (
        $("#btn_etc_opinionu" + _fileIndex) != null &&
        $("#btn_etc_opinionu" + _fileIndex).length > 0
      ) {
        $("#btn_etc_opinionu" + _fileIndex)[0].classList.toggle("active");
      }
      this.upfile.files.splice(_fileIndex, 1);
      
      this.deleteFileList.push(item);
    },
    delFile() {
      let obj = this;
      let axiosArr = [];   
      for (let inx = 0; inx < obj.deleteFileList.length; inx++) { 
        let url = "/api/cofile/paper/deleteAttach"
        let data = {
          groupId: obj.upfile.groupId,
          fileId: String(obj.deleteFileList[inx].fileItem.fileId),
        };  
        axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
      }
        
      if(axiosArr.length > 0) {
        let deleteTotalCount = obj.deleteFileList.length;
        let deleteFileFailCount = 0;
        axios.all(axiosArr).then(axios.spread((...responses) => {
          let setDeletePaperFileList = [];
          for(let k in responses){
            if (
              responses[k].data.errorCode != null &&
              responses[k].data.errorCode != undefined &&
              responses[k].data.errorCode.length > 0
            ) {
              // console.log(" 삭제 실패.");
              deleteFileFailCount++;
            }else{ 
              let fileItem= JSON.parse(responses[k].config.data); 
              setDeletePaperFileList.push(fileItem);
            }
          }

          if(deleteFileFailCount != 0){
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardOpinionModal.025","알 수 없는 오류로 {total}건 파일 중 {cnt}건이 삭제가 되지 않았습니다 확인 후 다시 시도해주세요.", {totalCnt: deleteTotalCount, cnt: deleteFileFailCount}));
          }

          axiosArr = [];
          // 삭제된 파일에 대해서 cowork_paper의 TB_PAPER_FILE DB 삭제.
          for (let inx = 0; inx < setDeletePaperFileList.length; inx++) { 
            let url = "/api/copaper/decision/deleteDecisionPaperFile"
            let data = {
              paperId: obj.editorData.paperId,
              paperFileId: obj.editorData.paperFileId,
              fileId: String(setDeletePaperFileList[inx].fileId),
              regUserId: obj.editorData.regUserId,
            };  
            axiosArr.push(axios.post(url, data, {responseType: 'json'})); 
          }

          axios.all(axiosArr).then(axios.spread((...responses2) => {
            obj.deleteTotalCount = 0;
            obj.deleteFileFailCount = 0;
            obj.deleteFileList = [];
          })).catch(errors => {});
        })).catch(errors => {});
      } 
    },
    deleteDecisionPaperFile(param) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/deleteDecisionPaperFile",
        method: "post",
        params: {
          paperId: obj.editorData.paperId,
          paperFileId: obj.editorData.paperFileId,
          fileId: param,
          regUserId: obj.editorData.regUserId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.getDecisionThisFile();
        obj.toastInfo.message = obj.$i18nUtil.trans("TB011"); // 파일이 삭제되었습니다.
        obj.showToast(obj.toastInfo);
      });
    },
    downloadOpinionFile(_fileItem, _fileIndex) {
      if (
        $("#btn_etc_opinionu" + _fileIndex) != null &&
        $("#btn_etc_opinionu" + _fileIndex).length > 0
      ) {
        $("#btn_etc_opinionu" + _fileIndex)[0].classList.toggle("active");
      }
      if (_fileItem.fileId == null) {
        this.showAlertDialog(this.$i18nUtil.trans("message.BoardOpinionModal.014","등록이 안된 파일입니다."), null, {
          width: "440px",
        });
        return;
      }
      let header = { responseType: "blob", "Content-Type": "application/json" };
      let fileName = _fileItem.fileName;
      let param = {
        fileId: _fileItem.fileId,
        type: "SINGLE",
        groupId: this.upfile.groupId,
      };
      let url = "/api/cofile/cofile/download";
      this.$axios
        .post(url, param, header)
        .then((res) => {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const url = window.URL.createObjectURL(blob);
          /* IE에서 발생하는 오류 억제 */
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement("a");
            const contentDisposition =
              res.headers["content-disposition"]; /* 파일 이름 */
            link.target = "_self";
            link.href = url;
            link.setAttribute("download", fileName);
            link.style.cssText = "display:none";
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        })
        .catch(function (err) {
          console.log("파일 업로드 실패");
          console.log(err);
        });
    },
    /* synap 파일 뷰어 호출 */
    callFileViewer(param) {
      let obj = this;
      if (param.file.fileId == null || param.file.fileId == "undefined") {
        obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardOpinionModal.015","저장 후에 파일을 볼 수 있습니다."), null, {
          width: "440px",
        });
        return;
      }

      let reqData = {
        url: "/api/copaper/decision/checkUploadStatus",
        method: "post",
        params: param.file,
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          let uploadStatus = res.result.uploadStatus;
          if (uploadStatus == "COMPLETE") {
            // this.$router.push(
            // 	"/general/viewer/" + this.upfile.groupId + "/" + param.fileId
            // );
            let hanwha = $(location).attr("origin");
            let groupId = obj.upfile.groupId;
            if (groupId != null || groupId != "") {
              window.open(
                hanwha + "/general/viewer/" + groupId + "/" + param.file.fileId
              );
            }
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.016","파일 업로드 처리중입니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
          obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinionModal.016","파일 업로드 처리중입니다.");
          obj.showToast(obj.toastInfo);
        });
    },
    onSubmitFormUpdate() {
      let obj = this;
      let reqDataModalsDecision = {
        url: "/api/copaper/decision/getModalsDecision",
        method: "post",
        params: { paperId: this.item.paperId, deciId: this.item.deciId },
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqDataModalsDecision).then((response) => {
        let editorData2 = response.result;

        if (obj.editorData.userId == null || obj.editorData.userId == "") {
          this.showAlertDialog(this.$i18nUtil.trans("message.BoardOpinionModal.017","결정자를 입력해 주세요."), null, {
            width: "440px",
          });
          return;
        }
        if (obj.editorData.contents == null || obj.editorData.contents == "") {
          this.showAlertDialog(this.$i18nUtil.trans("message.BoardOpinionModal.018","내용을 입력해 주세요."), null, {
            width: "440px",
          });
          return;
        }
        if (editorData2.confirm > 0) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB067"), null, {
            width: "440px",
          });
          return;
        }

        //프로그레스바 시작
        this.showLoadingbar();

        // obj.closePopup();
        if(obj.deleteFileList.length > 0){  
          obj.delFile(); 
        }

        if (obj.upfile.files.length) {
          obj.data.frm = new FormData();

          obj.data.sendType = "post";
          obj.data.url = "/api/cofile/paper/uploadDecision";
          obj.data.header = {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("Authorization"),
          };
          for (let i = 0; i < obj.upfile.files.length; i++) {
            if (obj.upfile.files[i].id != undefined) {
              obj.checked.push(obj.upfile.files[i].id);
            } else {
              obj.data.frm.append("files", obj.upfile.files[i]);
            }
          }
          obj.data.frm.append("groupId", obj.upfile.groupId);
          obj.data.frm.append("paperId", obj.upfile.paperId);
          obj.data.frm.append(
            "sharepointSiteId",
            obj.modalInfo.paperInfo.sharepointSiteId
          );
          obj.data.frm.append(
            "sharepointFolderId",
            obj.modalInfo.paperInfo.sharepointFolderId
          );
          obj.data.frm.append("paperFileId", editorData2.paperFileId);

          let object = obj.data;
          let url = object.url;
          let frm = object.frm;
          let header = object.header;
          let sendType = object.sendType;
          obj.$axios
            .post(url, frm, header)
            .then((response) => {
              //프로그레스바 종료
              this.hideLoadingbar();
              if (
                response.data.errorCode !== null &&
                response.data.errorCode !== undefined
              ) {
                console.log(
                  "/api/cofile/paper/uploadDecision 파일 업로드 에러 ",
                  response.data.errorCode
                );
                let errorCode = response.data.errorCode;
                if (errorCode === "COFILE_STORAGE_CAPACITY_EXCEEDED") {
                  obj.showAlertDialog(
                    obj.$i18nUtil.trans("AB054", { groupKbn: response.data.errorMessage })
                  );
                  return;
                } else if (errorCode === "COFILE_FILE_UPLOAD_DENIED") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB069"));
                  return;                  
                } else if (errorCode === "COFILE_FILE_UPLOAD_CAPACITY_EXCEEDED") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB108",{ limitSize: response.data.errorMessage /1024 /1024 }));
                  return;                  
                }else if (errorCode === "COFILE_FILE_UPLOAD_FAIL") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB070"));
                  return;
                } else if (
                  errorCode === "COFILE_FILE_UPLOAD_DENIED_FROM_EXTERNAL"
                ) {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB100"));
                  return;
                }
                return;
              }
              let isAuth = false;
              if (
                response.data.fncAuthRst !== null &&
                response.data.fncAuthRst !== undefined
              ) {
                if (
                  response.data.fncAuthRst.allow &&
                  response.data.fncAuthRst.authFlag.indexOf("W") > -1
                ) {
                  isAuth = true;
                } else {
                  isAuth = false;
                  console.log(
                    "/api/cofile/paper/uploadDecision 파일 업로드 에러 권한 리턴 ",
                    response.data.fncAuthRst
                  );
                }
              } else {
                isAuth = false;
                console.log(
                  "/api/cofile/paper/uploadDecision 파일 업로드 에러 권한 리턴 ",
                  response.data.fncAuthRst
                );
              }
              if (!isAuth) {
                this.showAlertDialog(this.$i18nUtil.trans("message.BoardOpinionModal.021","파일 업로드 권한이 없습니다."), null, {
                  width: "440px",
                });
                return;
              }
              let uploadDecision = response.data.result.uploadList;
              let uploadFailList = response.data.result.uploadFailList;
              let makingurl = "/api/copaper/decision/makingUpdate";
              // 파일 하나라도 업로드가 실패했을 경우
              if (uploadFailList.length > 0) {
                obj.showAlertDialog(obj.$i18nUtil.trans("AB071"));
              }

              // 결정자 set..
              obj.editorData.userId = obj.editorData.userId;
              obj.editorData.userName = obj.editorData.userName;

              let makingparam = {
                makingData: obj.editorData,
                //uploadDecision: uploadDecision,
                flag: "UPDATE",
              };
              obj.$axios
                .post(makingurl, makingparam)
                .then((makingRes) => {
                  if (obj.checked != null && obj.checked.length > 0) {
                    obj.copyBlockToDecision();
                  } else {
                    obj.copaperInsert(0, "");
                  }
                  EventBus.$emit("refreshPerDeciNewPage");
                  if (obj.item.paperBlockId) {
                    EventBus.$emit(
                      "DecisionBlockWidgetRefresh",
                      obj.item.paperBlockId
                    );
                  }
                })
                .catch((err) => {
                  console.log("axios err => ", err);
                });
            })
            .catch((err) => {
              //프로그레스바 종료
              this.hideLoadingbar();
              console.log("axios err => ", err);
            });
        } else {
          let _obj = this;
          let makingurl = "/api/copaper/decision/makingUpdate";
          // 결정자 set..
          _obj.editorData.userId = _obj.editorData.userId;
          _obj.editorData.userName = _obj.editorData.userName;
          let makingparam = { makingData: obj.editorData, flag: "UPDATE" };
          obj.$axios.post(makingurl, makingparam).then((response) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            _obj.items = response.data.result;
            _obj.$emit("closeBoardLeftModal", _obj.items);

            _obj.closePopup();
            EventBus.$emit("refreshPerDeciNewPage");
            EventBus.$emit("updatePaperUser");
            if (obj.item.paperBlockId) {
              EventBus.$emit(
                "DecisionBlockWidgetRefresh",
                obj.item.paperBlockId
              );
            }
          })
          .catch((err) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            console.log("axios err => ", err);
          });
        }
      });
    },
    boardFile() {
      const modalInfo = {
        name: "boardFile",
        obj: this.$modal,
        component: boardFile,
        width: "800px",
        //height: "862px",
        item: {
          groupId: this.upfile.groupId,
          paperId: this.upfile.paperId,
          deciId: this.editorData.deciId,
        },
      };
      this.showModal(modalInfo);
      if ($("#btn_output_up") != null && $("#btn_output_up").length > 0) {
        $("#btn_output_up")[0].classList.toggle("active");
      }
    },
    OpinionChangeFile() {
      if (
        this.$refs.opiUploadfile.files == null ||
        this.$refs.opiUploadfile.files.length == 0
      ) {
        return;
      }
      let files = this.$refs.opiUploadfile.files;
      if (files.length) {
        for (let i = 0; i < files.length; i++) {
          this.upfile.files.push(files[i]);
        }
      }
      // this.opinionUpfile.files = [];
    },
    pcontentsChk() {
      let obj = this;
      if (event.target.value.length > 0) {
        this.error = false;
      } else {
        this.error = true;
      }
    },
    icoFile(fileItem) {
      if (fileItem.type != null) {
        if (fileItem.type == "application/pdf") {
          return "ico-file-pdf";
        } else if (fileItem.type == "image/jpeg") {
          return "ico-file-jpg";
        } else if (fileItem.type.indexOf("presentation") != -1) {
          return "ico-file-ppt";
        } else if (fileItem.type.indexOf("sheet") != -1) {
          return "ico-file-xlsx";
        } else if (fileItem.type.indexOf("text") != -1) {
          return "ico-file-txt";
        }
      } else {
        let fileName = fileItem.fileName;
        let str = fileName.substring(fileName.length - 4, fileName.length);
        if (str.indexOf("pdf") != -1) {
          return "ico-file-pdf";
        } else if (str.indexOf("jpg") != -1) {
          return "ico-file-jpg";
        } else if (str.indexOf("ppt") != -1) {
          return "ico-file-ppt";
        } else if (str.indexOf("xlsx") != -1) {
          return "ico-file-xlsx";
        } else if (str.indexOf("txt") != -1) {
          return "ico-file-txt";
        }
      }
    },
    copyBlockToDecision() {
      let obj = this;
      let returnResult = null;
      let chkval = [];

      for (let index = 0; index < this.checked.length; index++) {
        chkval.push(this.checked[index]);
      }
      let reqData = {
        url: "/api/cofile/paper/copyBlockToDecision",
        method: "post",
        reqMap: {
          groupId: this.upfile.groupId,
          paperId: this.upfile.paperId,
          fileIds: chkval,
        },
      };
      this.$axios
        .post(reqData.url, reqData.reqMap)
        .then((res) => {
          let errorCode = res.data.errorCode;
          if (errorCode == null) {
            returnResult = res.data.result.result;
            this.copaperInsert(0, returnResult);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    copaperInsert(index, returnResult) {
      let max = returnResult.length;
      if (returnResult[index] == null) {
        if (index + 1 < max) {
          this.copaperInsert(index + 1, returnResult);
        } else {
          EventBus.$emit("outputBoardInsert", "outputBoardInsert");
          this.closePopup();
        }
      }
      if (returnResult[index]) {
        let obj = this;
        let reqData = {
          url: "/api/copaper/decision/copyBlockToDecision",
          method: "post",
          params: {
            fileId: returnResult[index].fileId,
            fileExt: returnResult[index].fileExt,
            fileName: returnResult[index].fileName,
            locationId: returnResult[index].locationId,
            tenantId: returnResult[index].tenantId,
            groupId: returnResult[index].groupId,
            deciId: this.editorData.deciId,
          },
        };
        this.$axios.post(reqData.url, reqData.params).then((response) => {
          if (index + 1 < max) {
            this.copaperInsert(index + 1, returnResult);
          } else {
            obj.$emit("closeBoardLeftModal", obj.items);
            obj.closePopup();
          }
        });
      }
    },
    updateUserPhoto() {
      let list = this.$el.querySelectorAll("div.user-photo[data-user-id]");
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let userId = elem.getAttribute("data-user-id");
          let img = elem.querySelector("img");
          this.HW_GET_USER_PHOTO({ img, userId });
        }
      }
    },
    getMemberTooltip(param) {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/todo/getMemberTooltip";
      reqData.method = "post";
      reqData.params = {
        userId: param,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode) {
          console.log("/getMemberTooltip errorCode", response.errorCode);
        }
        this.deptInfo = response.result;
      });
    },
    clickMemberSearchBtn() {
      if (this.searchKeyword.length > 0) {
        this.isSearch = false;
        this.searchKeyword = "";
      }
    },
    searchByKeyword(event) {
      let obj = this;
      if (event.target.value.length > 1) {
        event.target.parentElement.classList.add("active");
        this.isSearch = true;
        let reqData = {};
        reqData.req = {
          searchKeyword: event.target.value,
        };
        reqData.url = "/api/auth/org/searchByUserName";
        reqData.method = "post";

        obj
          .COWORK_REST_ACTION(reqData)
          .then(function (data) {
            obj.userListS = data.result;
            setTimeout(obj.updateUserPhoto, 500);
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        event.target.parentElement.classList.remove("active");
        obj.userListS.splice(0, obj.userListS.length);
        this.isSearch = false;
      }
    },
    replaceAll(str, input, output) {
      return str.split(input).join(output);
    },
    decisionDragDropFile(e, type) {
      if (this.editorData.regUserId != this.userInfo.userId) {
        return;
      }
      let obj = this;
      let decisionDropZone = obj.$refs.decisionDropZone;

      if (
        e.dataTransfer &&
        e.dataTransfer.types &&
        e.dataTransfer.types[0] === "Files"
      ) {
        e.preventDefault();
        e.stopPropagation();

        if (type === "drop" && e.dataTransfer.files) {
          decisionDropZone.classList.remove("dropdown-file");

          if (e.target.classList.contains("decisionDropZone")) {
            let uploadFileList = e.dataTransfer.files;
            for (let idx = 0; idx < uploadFileList.length; idx++) {
              obj.upfile.files.push(uploadFileList[idx]);
            }
          }
        } else if (type === "leave") {
          let leaveHandle = decisionDropZone.getAttribute("leave-handle");
          if (leaveHandle) {
            clearTimeout(leaveHandle);
          }
          leaveHandle = setTimeout(function () {
            decisionDropZone.classList.remove("dropdown-file");
          }, 100);
          decisionDropZone.setAttribute("leave-handle", leaveHandle);
        } else if (type === "over") {
          let leaveHandle = decisionDropZone.getAttribute("leave-handle");
          if (leaveHandle) {
            clearTimeout(leaveHandle);
          }
          decisionDropZone.classList.add("dropdown-file");
        }
      }
    },
    boardLink() {
      window.open("/general/boardTarget/" + this.editorData.paperId + "/" + this.editorData.paperBlockId, "_blank");
    },
    searchByKeyword(event) {
      let obj = this;
      let memberSearch = obj.$refs.memberSearchList.parentNode;
      obj.SIMPLE_KBD_SCROLL({
        event: event,
        index: obj.state.memberIndex,
        offsetTop: memberSearch.classList.contains("search_list_reverse")
          ? 0
          : -80,
        root: obj.$el,
        itemQuery: ".member-call-box .scroll li",
        scrollQuery: ".member-call-box .scroll",
        pointerClass: "selected",
        onSelect(e, inx, elem) {
          // console.log("SELECTED:", inx, elem);
          if (elem) {
            let userId = elem.getAttribute("data-user-id");
            let userName = elem.getAttribute("data-user-name");
            event.target.value = "";
            obj.setuserId(userId, userName);
          }
        },
        onCancel(e) {
          lodash.debounce(() => {
            // console.log("CANCELED!");
            if (!event.target.value) {
              obj.$refs.memberSearchBtn.$el.click();
            }
            event.target.value = "";
            obj.searchByKeywordWrapper(e);
          }, 10)();
        },
        callback(e, fncScroll) {
          lodash.debounce(() => {
            // console.log("SEARCHING..", e);
            obj.searchByKeywordWrapper(e, fncScroll);
          }, 500)();
        },
      });
    },
    searchByKeywordWrapper(event, fncScroll) {
      let obj = this;
      this.searchKeyword = event.target.value;
      if (this.searchKeyword.length > 1) {
        this.isSearch = true;
        let reqData = {};
        reqData.req = {
          searchKeyword: this.searchKeyword,
        };
        reqData.url = "/api/auth/org/searchByUserName";
        reqData.method = "post";

        obj
          .COWORK_REST_ACTION(reqData)
          .then(function (data) {
            obj.searchMemberList = [];
            obj.searchNoMemberList = [];
            obj.searchUserList = data.result;
            obj.searchUserList.forEach((item) => {
              let memberCheck = false;
              obj.members.forEach((value) => {
                if (value.userId == item.userId) {
                  memberCheck = true;
                }
              });
              if (memberCheck) {
                obj.searchMemberList.push(item);
              } else {
                obj.searchNoMemberList.push(item);
              }
              if (fncScroll) {
                obj.state.memberIndex[0] = 0;
                fncScroll(obj.state.memberIndex);
              }
            });
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        this.isSearch = false;
      }
    },
    showMemberSearch(e) {
      let self = this;
      self.CHECK_AND_LAUNCH({
        check(ctx) {
          return (ctx.ret = self.$refs.memberSearchList);
        },
        launch(ctx) {
          let wscrollTop = window.scrollY || window.pageYOffset;
          let wHeight = window.innerHeight;
          let memberSearch = ctx.ret.parentNode;
          // console.log("TOP:", self.$el.offsetTop, wscrollTop, wHeight, wHeight - self.$el.offsetTop + wscrollTop);
          if (wHeight - self.$el.offsetTop + wscrollTop > 380) {
            memberSearch.classList.add("search_list_normal");
            memberSearch.classList.remove("search_list_reverse");
          } else {
            memberSearch.classList.remove("search_list_normal");
            memberSearch.classList.add("search_list_reverse");
          }
        },
      });
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      if (this.modalInfo.onclose) {
        this.modalInfo.onclose();
      }
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
  [class*="todo_wrap"] .enCss {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/opinion/BoardOpinionModal.vue